<template>
  <div class="container">
 <br />
  
    <h2>Create Event</h2>
   <hr />
    
    <div class="seasoncast-card">
      <p>Event Type:</p>
      <div class="form-check form-check-inline">
  <input class="form-check-input" type="radio" v-model="eventType" id="inlineRadio1" value="sport">
  <label class="form-check-label" for="inlineRadio1">Sport Event</label>
</div>
<div class="form-check form-check-inline">
  <input class="form-check-input" type="radio" v-model="eventType" id="inlineRadio2" value="general">
  <label class="form-check-label" for="inlineRadio2">General Event </label>
</div>
<br />
<br />

        <p>Scheduled Date:</p><date-picker v-model="startDate"  :config="dateConfig" ref="dateS" ></date-picker><br />
        <div v-if="eventType == 'sport'">
          <p>Sport:</p> <select class="custom-select"  v-model="sport">
               
               <option value="Baseball">Baseball</option>
               <option value="Volleyball">Volleyball</option>
                <option value="Basketball">Basketball</option>
                 <option value="Tennis">Tennis</option>
                  <option  :disabled="!channel.premium.active" value="Soccer">Soccer <span v-if="!channel.premium.active">(Premium Req.)</span></option>
                  <option :disabled="!channel.premium.active" value="Football">Football <span v-if="!channel.premium.active">(Premium Req.)</span></option>
               <option :disabled="!channel.premium.active" value="Softball">Softball <span v-if="!channel.premium.active">(Premium Req.)</span></option>
                   <option :disabled="!channel.premium.active" value="Hockey">Hockey <span v-if="!channel.premium.active">(Premium Req.)</span></option>
                   <option :disabled="!channel.premium.active" value="Rugby">Rugby <span v-if="!channel.premium.active">(Premium Req.)</span></option>
                   <option :disabled="!channel.premium.active" value="Handball">Handball <span v-if="!channel.premium.active">(Premium Req.)</span></option>
                   <option :disabled="!channel.premium.active" value="Floorball">Floorball <span v-if="!channel.premium.active">(Premium Req.)</span></option>
               <option :disabled="!channel.premium.active" value="Other">Other <span v-if="!channel.premium.active">(Premium Req.)</span></option>
             </select>
              <span style="color:red" v-if="!channel.premium.active">Upgrade to 'Broadcaster Premium' for all sport options</span><br /><br />
      <div v-for="(team, index) in teams" v-bind:key="index" >
    <p>Team {{ index + 1 }}:</p>
   <select class="custom-select" v-model="team.id" @change="updateTeams"  >
    <option :value="undefined" >Setup New Team</option>
    <option v-for="teamOption in teamOptions"   :value="teamOption.id" :key="teamOption.id" :disabled="teamOption.sport != sport">{{ teamOption.name + " - "+ teamOption.sport +" Team"}}</option>
    </select>
    <br />
    <br />
    <div v-if="team.id == undefined"> 
      <p>Team {{ index + 1 }} Name:</p><input v-model="team.name" type="text" class="form-control" aria-label="Text input with checkbox"> <br />
        <p>{{ team.name }} Team Color:</p> <span style="color:red" v-if="!channel.premium.active">Broadcaster Premium required to change team color<br /></span><chrome-picker v-if="channel.premium.active" v-model="team.color" @input="team.color.hex ? team.color = team.color.hex : false" /> <br />
      </div>
    </div>
       
      
</div>
  <div v-if="eventType == 'general'">
    <p>Event Name:</p><input v-model="eventName" type="text" class="form-control"  aria-label="Text input with checkbox">
   </div>
  <br />
   <br />
    <button @click="createEvent" class="btn btn-block btn-dark">Create Event</button>
     
  
</div>
<br />
</div>


</template>

<script>

import axios from "axios"
import Swal from "sweetalert2"
import { Chrome } from 'vue-color'
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

let API = "https://app.seasoncast.com/"

export default {
  name: 'Home',
  props: ['channel'],
  components: {
      'chrome-picker':Chrome,
datePicker
  },
  
  data: function () {
    return {
      eventType: "sport",
      recordingsList: [],
      teamOptions: [],
        eventList: [],
        teams: [
                           {
                        name: "Home",
                        score: 0,
                        color: '#7d7d7d'
                    },
                       {
                        name: "Away",
                        score: 0,
                        color: '#2C2C2C'
                    }
        ],

        eventName: undefined,
        sport: "Baseball",
        startDate: new Date(),
        dateConfig: {
            sideBySide: true,
            minDate: new Date()
        }

    }
  },
  watch: {
   
    sport: function () {
      this.teams= [     {
                        name: "Home",
                        score: 0,
                        color: '#7d7d7d'
                    },
                                        {
                        name: "Away",
                        score: 0,
                        color: '#2C2C2C'
                    }]
    },
    teams: function () {
      this.teams.forEach((team) => {
       if (team.id){
        team = this.teamOptions.find(teamOption => teamOption.id == team.id)
       }
      })
    }
  },
  created: async function () {
    this.getTeams()
  },
  methods: {
    updateTeams: function () {
      this.teams.forEach((team) => {
       if (team.id){
        const teamSelected = this.teamOptions.find(teamOption => teamOption.id == team.id)
        team.name = teamSelected.name
        team.color = teamSelected.color

       }
      })
    },
    createEvent: async function () {
      if (!this.sport || !this.startDate ){
               await Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'Not all inputs vaild',

})
          return
      }
      var event = {
                eventName: this.eventName || (this.teams.length == 2 ? (this.teams[0].name + " vs "+ this.teams[1].name) : "A Event"),
                timeStart: parseInt( new Date(this.startDate).getTime() / 1000),
                type: this.eventType,
                teams: this.teams,
                global: {  "extraText": "Live Event",
            "brand": "SeasonCast Broadcaster"}
            }

            if (this.eventType == "general"){

              event.teams = []
             
            }else{

              event.sport = this.sport
              event.global.sport = this.sport
            }
            console.log(event)
    let getEventResponse = await axios.post(API+ "v2/broadcaster/event/create", {
            event: event,
            ...this.$store.state.broadcasterAuth,
}) 

  let responseData = getEventResponse.data


if (responseData.id){
    this.$router.push("/broadcaster/event/"+responseData.id)
}



    },
    getTeams: async function () {
      let getTeamsResponse = await axios.post(API+ "v2/broadcaster/teams", {
            eventID: this.$route.params.id,
            ...this.$store.state.broadcasterAuth,
})
   this.teamOptions = getTeamsResponse.data.result
    },
  }
}
</script>
<style lang="scss">

</style>
